<template>
  <el-dialog
    title="报团服务费率系数设置"
    :visible.sync="percentVisible"
    width="45%"
    :before-close="handleClose"
    center
    >
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="报团服务费率系数" prop="rate">
            <el-input size="small" v-model="form.rate" placeholder="请输入报团服务费率系数">
                <template slot="append">%</template>
            </el-input>
        </el-form-item>
    </el-form>
    <!--  -->
    <div class="express">
        <div>
            报团服务费率=你的商品服务费率*系数
        </div>
        <div style="marginTop:10px;">
            1、所有可参与报团的商品都将按照系数自动计算报团服务费率，您可在商品库对指定商品修改报团
            服务费率
        </div>
    </div>
    <!--  -->
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" style="backgroundColor:#F2F2F5;color:#45474D;borderColor:#FFFFFF" @click="handleClose">取 消</el-button>
        <el-button size="mini" style="backgroundColor:#fe2c55;color:#FFFFFF;borderColor:#FFFFFF" @click="handleConfirm">确 定</el-button>
    </span>
    </el-dialog>
</template>

<script>// @ts-nocheck

import { getServePercent ,setServePercent } from '@/api/goods.js'
export default {
    props:{
        percentVisible:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            form: {
                rate: ''
            },
            rules: {
                rate: [
                    { required: true, message: '请输入报团服务费率系数', trigger: 'blur' },
                ]
            }
        }
    },
    watch:{
        percentVisible(val){
            if(val){
                // 每次打开重置表单校验
                this.$nextTick(()=>{
                    this.$refs['form'].resetFields();
                    this.getServePercent()
                })
            }
        }
    },
    methods:{
        // 获取服务费率
        getServePercent(){
            getServePercent({

            }).then( res => {
                if(res.code==800){
                    this.form.rate = res.data
                }
            })
        },
        // 取消
        handleClose(){
            this.$emit('cancel','cancel')
        },
        //确认
        handleConfirm(){
            // handle
            this.$refs['form'].validate((valid)=>{
                if(valid){
                    setServePercent({
                        ...this.form
                    }).then( res => {
                        if(res.code==800){
                            this.$message.success(res.msg)
                            this.$emit('success','success')
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                }else{
                    console.log('error submit!!');
                    this.$message.error('请完整填写!')
                    return
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header{
    border-bottom: solid 1px #E6E7EB;
}
/deep/.el-input__inner{
    height: 40px;
}
/deep/.el-input-group--append{
    height: 40px;
}
.express{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #8A8E99;
}
</style>